export default __webpack_public_path__ + "resources/icons/n210-4dc1.png";